import { gsap } from 'gsap'

const cursor = document.querySelector('#cursor')
const links = document.querySelectorAll('a, button, .button, body.single-projets section[data-photos] .photos figure')

function isMobile(){
	return (innerWidth < 1240)
}

if (cursor && !isMobile())
{
	initCursor()
}

function initCursor ()
{
	gsap.set(cursor, { xPercent: -50, yPercent: -50 })
	
	window.addEventListener('mousemove', e =>
	{
		gsap.set(cursor, {
			x: e.clientX,
			y: e.clientY
		})
	})
	
	links.forEach(el =>
	{
		el.addEventListener('mouseover', () =>
		{
			/*gsap.to(cursor, {
				opacity: 0.3,
				scale: 2,
				duration: 0.2
			})*/
			
			gsap.set(cursor, {
				opacity: 0
			})
		})
		
		el.addEventListener('mouseout', () =>
		{
			/*gsap.to(cursor, {
				opacity: 1,
				scale: 1,
				duration: 0.2
			})*/
			
			gsap.set(cursor, {
				opacity: 1
			})
		})
	})
}

